/**
 * Initialize anchor scrolling with offset for fixed header
 */
export function initAnchorScroll() {
    const handleScroll = (hash) => {
        if (!hash || hash === '#') return;

        const id = hash.replace('#', '');
        if (!id) return;

        const element = document.getElementById(id);

        if (element) {
            const headerElement = document.querySelector('header');
            // Dynamically calculate header height
            let headerOffset = headerElement ? headerElement.offsetHeight : 186;

            // Add a small margin (15px) for premium breathing room below the sticky header/bar
            headerOffset += 15;

            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };

    // Handle hash on page load
    if (window.location.hash && window.location.hash !== '#') {
        // Wait a bit for content and images to load
        setTimeout(() => handleScroll(window.location.hash));
    }

    // Handle clicks on anchor links
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');

        if (
            link &&
            link.hash &&
            link.hash !== '#' &&
            link.origin === window.location.origin &&
            link.pathname === window.location.pathname
        ) {
            const id = link.hash.replace('#', '');
            if (id && document.getElementById(id)) {
                e.preventDefault();
                handleScroll(link.hash);
                window.history.pushState(null, null, link.hash);
            }
        }
    });
}
